import UserActivePlans from 'components/UserOrders/List/UserActivePlans';

const UserActivePlansPageList = () => {
	return <UserActivePlans />;
};

export default UserActivePlansPageList;
